import { useState, useEffect } from 'react';

const breakpoints = {
  mobile: 640,
  tablet: 1024,
  desktop: 1280,
};

export function useResponsive() {
  const [state, setState] = useState({
    device: 'mobile',
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      let device = 'mobile';

      if (w >= breakpoints.desktop) {
        device = 'desktop';
      } else if (w >= breakpoints.tablet) {
        device = 'tablet';
      }

      setState({ device, width: w, height: h });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    ...state,
    isMobile: state.device === 'mobile',
    isTablet: state.device === 'tablet',
    isDesktop: state.device === 'desktop',
    isTouch: state.device === 'mobile' || state.device === 'tablet',
  };
}

export default useResponsive;
